import { MDBInput} from "mdb-react-ui-kit";
import React, { useState } from "react"
import axios from 'axios'
import sellP from "../Styles/SellProduct.css"
import Loading from '../Components/Loading'
import { json, useNavigate} from 'react-router-dom';
const SellProduct = () => 
{
    const[name,setName] = React.useState('');
    const[price,setprice] = React.useState('');
    const[phno,setphno] = React.useState('');
    const[category,setcat] = React.useState('Others');
    const[image,setimage] = React.useState('');
    const [errors,setError] = React.useState('');
    //loading
    const[loading,setLoading] = useState(false);
  
    //navigation
    const navigate = useNavigate();

    ///add product click handler
    const addproclick = async () => 
    {
        setLoading(true);
        if(!name || !price || !category ||  !phno ||  !image)
        {
            setError(true);
            alert("enter correct details");
            setLoading(false);
            return false;
        }
        console.warn(name,price,category,phno,image);
        const userId = JSON.parse( localStorage.getItem('user'))._id;
        //creating form data to be sent as we caanot send as in raw body
        const formdata =  new FormData();
        formdata.append('name' ,name);
        formdata.append('price' ,price);
        formdata.append('category' ,category);
        formdata.append('phno' ,phno);
        formdata.append('userId', userId);
        formdata.append('testImage' ,image);
        //sending post request
        axios.post('https://bechnaabackend.onrender.com/upload',
        formdata)
        .then((res) => 
        {
            console.log(res.data);
            window.alert("YOUR PRODUCT IS LIVE, REST TILL WE FIND A BUYER");
            setLoading(false);
            navigate('/');
        })
    }
    return(
        <>
        {
            loading === true ? (<Loading/>) :(<div className="addProduct" >
            <h3>Enter Product Details</h3>
           
            <label>Product Name(Include 3-4 word description)</label>
            { errors || !name && <span>Enter valid Details</span>}
            <MDBInput  type="text" value = {name} onChange={(e)=> {setName(e.target.value)}}/>

            <label>Price(in Rupees)</label>
             { errors  || !price && <span>Enter valid price</span>}
            <MDBInput   type="number"
            value = {price} onChange={(e)=> {setprice(e.target.value)}}/>
             <label>Phone Number</label>
            { errors || (phno.length != 10) && <span>Enter valid phone number</span>}
            <MDBInput  type="number" 
            value = {phno} onChange={(e)=> {setphno(e.target.value); }}/> 
            
             
            <div> 
            <p>Select Category</p>
            <select className="category" value ={category}  onChange={(e)=> {setcat(e.target.value)}}>  
                <option value="Others">Others</option> 
                <option value = "Cycle"> Cycle </option>
                <option value = "Electronics"> Electronics </option>
                <option value = "Books"> Books</option>   
            </select> 
            {/* /////////////UPLOAD IMAGE INPUT//////////////////////// */}
            {errors || !image && <span>Upload images</span>}
            <p></p>
            <input  type="file" onChange={(e) => setimage(e.target.files[0])} />
            </div>

            <button className="addPBtn" onClick={addproclick}>SUBMIT</button>
        </div>)
        }
        </>
        
    )
}
export default SellProduct;
